import { render, staticRenderFns } from "./GreenButton.vue?vue&type=template&id=10d86ef8"
import script from "./GreenButton.vue?vue&type=script&lang=ts"
export * from "./GreenButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports